import type { ScopeBrief } from '../types/content'

export const scopeBriefs: ScopeBrief[] = [
  {
    tag: 'AI ROI',
    title: 'The AI spend has no denominator',
    description:
      'Seats were bought, adoption is claimed, and nobody can connect either to delivery outcomes. I rebuild the picture from your historical engineering data, establish a credible pre-AI baseline, and produce a number you can defend line by line.',
  },
  {
    tag: 'Operating model',
    title: 'The org shipped faster at half the size',
    description:
      "Headcount grew, throughput did not. We look at where work actually queues: review latency, dependency chains, unplanned work, and the meetings that quietly own your senior engineers' calendars.",
  },
  {
    tag: 'Metrics',
    title: 'The dashboard nobody trusts',
    description:
      'Most measurement programs fail on politics, not data. I design the metric set, the review cadence, and the explicit rules on what will never be used in a performance review, which is the part that determines whether any of it survives.',
  },
  {
    tag: 'Build vs buy',
    title: 'Three teams are building the same internal tool',
    description:
      'A structured evaluation of what to build, what to buy, and what to retire, with the maintenance cost of the internal option priced honestly rather than assumed to be zero.',
  },
  {
    tag: 'Diligence',
    title: 'The target claims an engineering advantage',
    description:
      'For funds and acquirers: an independent read on delivery capability, key person concentration, code health, and whether the AI story in the deck is visible anywhere in the commit history.',
  },
]
